//React
import React from "react";
import {
  Link
} from "react-router-dom";
import Button from '@material-ui/core/Button';

import reactStringReplace from "react-string-replace";

class Comp extends React.Component {

  _url2Button(text) {
    let urlMatches = text.match(/\[(.*)\][ 　\-=>]+?(https?:\/\/www.partner-s.net)(\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)/g);

    if (urlMatches) {

      urlMatches.forEach((item, index) => {
        let redirectMatche = item.match(/\[(.*)\][ 　\-=>]+?(https?:\/\/www.partner-s.net\/redirect\/)([a-zA-Z0-9-]+)\/?/);
        if (redirectMatche) {

          const param = redirectMatche[3].split('-');
          let to = '/';
          if (param[0] === 'home') {
          	to = '/';
          }
          else if (param[0] === 'mailbox') {
          	if (param[1] === 'talk') {
              to = '/mailbox/talk/' + param[2];
          	}
          	else if (param[1] === 'draft') {
              to = '/mailbox/draft/';
          	}
            else {
              to = '/mailbox/';
            }
          }
          else if (param[0] === 'bestpartner') {
          	to = '/mailbox/bestpartner/';
          }
          else if (param[0] === 'my') {
          	if (param[1] === 'user') {
              to = '/my/user/';
          	}
          	else if (param[1] === 'partner') {
              to = '/my/partner/';
          	}
          	else if (param[1] === 'comment') {
              to = '/my/comment/';
          	}
          	else if (param[1] === 'photo') {
              to = '/my/#photoBlock';
          	}
          	else if (param[1] === 'proof') {
              if (param[2] === 'person') {
                to = '/my/proof/person';
              }
              else if (param[2] === 'photo') {
                to = '/my/proof/photo';
              }
              else if (param[2] === 'income') {
                to = '/my/proof/income';
              }
              else if (param[2] === 'single') {
                to = '/my/proof/single';
              }
              else {
                to = '/my/proof/';
              }
          	}
          	else if (param[1] === 'keyword') {
              to = '/my/keyword/';
          	}
          	else if (param[1] === 'post') {
              to = '/my/post/';
          	}
          	else if (param[1] === 'qaQuestion') {
              to = '/my/qa/question/';
          	}
          	else if (param[1] === 'qaAnswer') {
              to = '/my/qa/answer/';
          	}
          	else if (param[1] === 'personality') {
              to = '/my/personality/';
          	}
            else if (param[1] === 'paymentTicketSender') {
              to = '/my/paymentTicketSender/';
          	}
            else if (param[1] === 'paymentTicketReceiver') {
              to = '/my/paymentTicketReceiver/';
          	}
            else {
              to = '/my/';
            }
          }
          else if (param[0] === 'search') {
            to = '/search/';
          }
          else if (param[0] === 'profile') {
            to = '/profile/';
          }
          else if (param[0] === 'favorite') {
          	if (param[1] === 'my') {
              to = '/favorite/my/';
          	}
          	else if (param[0] === 'partner') {
              to = '/favorite/partner/';
          	}
          }
          else if (param[0] === 'setting') {
          	if (param[1] === 'name') {
              to = '/setting/name/';
          	}
          	else if (param[1] === 'charge') {
              to = '/setting/charge/';
          	}
          	else if (param[1] === 'chargeAuto') {
              to = '/setting/chargeAutomatic/';
          	}
          	else if (param[1] === 'loginId') {
              to = '/setting/loginId/';
          	}
          	else if (param[1] === 'loginPass') {
              to = '/setting/loginPass/';
          	}
          	else if (param[1] === 'email') {
              to = '/setting/email/';
          	}
          	else if (param[1] === 'emailNotification') {
              to = '/setting/#emailNotificationBlock';
          	}
            else if (param[1] === 'twoFactorAuth') {
              to = '/setting/twoFactorAuth/';
            }
          	else if (param[1] === 'filter') {
              to = '/setting/#filterBlock';
          	}
          	else if (param[1] === 'introduction') {
              to = '/setting/#introductionBlock';
          	}
          	else if (param[1] === 'nondisplay') {
              to = '/setting/nondisplay/';
          	}
          	else if (param[1] === 'refusal') {
              to = '/setting/refusal/';
          	}
          	else if (param[1] === 'timeline') {
              to = '/setting/timeline/';
          	}
          	else if (param[1] === 'search') {
              to = '/setting/#accountBlock';
          	}
          	else if (param[1] === 'stop') {
              to = '/setting/stop/';
          	}
          	else if (param[1] === 'outage') {
              to = '/setting/outage/';
          	}
          	else {
              to = '/setting/';
          	}
          }
          else if (param[0] === 'help') {
            to = '/help/';
          }
          else if (param[0] === 'campaign') {
            to = '/campaign/';
          }
          else if (param[0] === 'contact') {
            to = '/contact/' + param[1];
          }
          else if (param[0] === 'logout') {
            to = '/logout/' + param[1];
          }

          let buttonClick = () => {};
          if (this.props.buttonClick) {
            buttonClick = () => this.props.buttonClick();
          }

          text = reactStringReplace(text, redirectMatche[0], (match, i) => (
            <Link
              key={ index + '-' + i }
              to={ to }
              className='i-b'
              style={{margin:'3px'}}
            >
              <Button
                variant="contained"
                onClick={ buttonClick }
              >
                { redirectMatche[1] }
              </Button>
            </Link>
          ));
        }

        let linkMatches = item.match(/\[(.*)\][ 　\-=>]+?(https?:\/\/www.partner-s.net\/)([-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)/);
        if (linkMatches) {
          text = reactStringReplace(text, linkMatches[0], (match, i) => (
            <a key={ index + '-' + i } href={ linkMatches[2] + linkMatches[3] } className='i-b' style={{margin:'3px'}}>
              <Button
                variant="outlined"
              >
                { linkMatches[1] }
              </Button>
            </a>
          ));
        }
      });
    }

    return text;
  }


	render() {
		return (
			<div>
        {
          this._url2Button(this.props.text)
        }
			</div>
		)
	}
}

export default Comp;
